import React, { createContext, useEffect, useState } from "react";
import { PropsType } from "../../interfaces/ChildrenType";
import { LoanResponse } from "../../interfaces/Loan";
import { LoanResultContextType } from "./loan-types";

const LoanData = sessionStorage.getItem("pepper-user-loan");
const initialState: LoanResultContextType = {
  loanResult: JSON.parse(LoanData as string) || undefined,

  setLoanResult: () => { },
};

export const LoanResultContext = createContext(initialState);

export const LoanResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [loanResult, setLoanResult] = useState<
    LoanResponse[] | undefined
  >(initialState.loanResult);

  useEffect(() => {
    if (loanResult) {
      sessionStorage.setItem('pepper-user-loan', JSON.stringify(loanResult))
    } else {
      sessionStorage.removeItem("pepper-user-loan");
    }
  }, [loanResult])

  return (
    <LoanResultContext.Provider
      value={{ loanResult, setLoanResult }}
    >
      {children}
    </LoanResultContext.Provider>
  );
};
